import { stringToDate } from "@dhx/ts-common/date";
import { DataPage } from "@xbs/muon";
import { setAutoHeightToRow } from "../helpers/actions";
import { getExcelDateFromJs, timeStringToJS } from "../helpers/date";
import { getCleanValue, getDefaultFormats, isNumeric } from "../helpers/format";
import { getCellInfo, getCellIds, doesContainUrl, isURL } from "./../helpers/main";
import { IAction, IActionConfig, SpreadsheetEvents } from "./../types";
declare const dhx: any;

export class SetCellValue implements IAction {
	public config: IActionConfig;
	private _page: DataPage;
	private _page_rows: { height: number }[];

	constructor(config: IActionConfig) {
		this.config = config;
		this._page = config.page;
	}

	do() {
		const { cell, grid } = this.config;
		const { row, col } = getCellIds(cell, grid);
		let value = this.config.val;
		const spreadsheet = this.config.spreadsheet;
		if (spreadsheet.isLocked(cell)) {
			return;
		}
		if (!spreadsheet.events.fire(SpreadsheetEvents.beforeValueChange, [cell, value])) {
			return;
		}

		const math = spreadsheet.getFormula(cell);
		this.config.prev = math ? "=" + math : spreadsheet.getValue(cell);
		let {format, link} = getCellInfo(cell, this._page, grid);

		if (typeof value === "string" && value.startsWith("=") && format?.mask !== "@") {
			const openParenthesis = value
				.split("")
				.reduce((c: number, i: string) => (i === "(" ? c + 1 : c), 0);
			let closeParenthesis = value
				.split("")
				.reduce((c: number, i: string) => (i === ")" ? c + 1 : c), 0);

			while (closeParenthesis < openParenthesis) {
				value += ")";
				closeParenthesis++;
			}

			try {
				this._page.setValue(+row, +col, value);
			} catch (e) {
				// do nothing
			}
		} else if (format?.id === "date" && value) {
			let val;
			if (isNumeric(value)) {
				val = +value;
			} else if (stringToDate(value as string, format.dateFormat, true)) {
				val = getExcelDateFromJs(stringToDate(value as string, format.dateFormat));
			} else {
				val = value;
			}
			this.config.val = val;
			this._page.setValue(+row, +col, this.config.val);
		} else if (format?.id === "time" && value) {
			let val;
			if (isNumeric(value)) {
				val = +value;
			} else {
				const time = timeStringToJS(value);
				val = typeof time === "string" ? time : getExcelDateFromJs(time);
			}
			this.config.val = val;
			this._page.setValue(+row, +col, this.config.val);
		} else if (format?.id === "percent") {
			const clean = getCleanValue(value);
			const val = +(parseFloat(clean) / 100).toFixed(4);
			// tslint:disable-next-line
			this._page.setValue(+row, +col, val || "");
		} else if (format?.id !== "text") {
			const numValue = parseFloat(value);
			// tslint:disable-next-line
			this._page.setValue(+row, +col, numValue == value ? numValue : value);
		} else {
			this._page.setValue(+row, +col, value, 1);
		}

		this._page.setCell(row, col, {
			nextValue: undefined,
			edited: false,
			format: format || getDefaultFormats().filter(i => i.id === "common")[0],
		});
		const { css = "" } = getCellInfo(cell, this._page, grid);
		if (css) {
			const { multiline } = dhx.css.get(css) || {};
			if (multiline) {
				this._page_rows = [...this._page.getMeta().rows];
				if (setAutoHeightToRow(cell, this.config.grid, this._page, multiline)) {
					(this.config.spreadsheet as any)._updateGridState();
				}
			}
		}
		const href = doesContainUrl(value);
		if (href) {
			this._page.setCell(row, col, {
				css: isURL(value) ? `dhx_spreadsheet_link ${css}` : css,
				link: {href}
			});
		}
		if (!value) {
			this._page.setCell(row, col, {
				css: css?.split("dhx_spreadsheet_link ").join(""),
				link: null
			});
		}
		this._page.setMeta({ inserted: true });
		this.config.grid.paint();
		spreadsheet.events.fire(SpreadsheetEvents.afterValueChange, [this.config.cell, value]);
	}

	undo() {
		const val = this.config.val;
		const prev = this.config.prev;
		if (this._page_rows) {
			this._page.setMeta({ rows: this._page_rows });
			(this.config.spreadsheet as any)._updateGridState();
		}
		this.config.val = prev;
		this.config.prev = val;
		this.do();

		this.config.val = val;
		this.config.prev = prev;
	}
}
